export default {
  name: 'Breadcrumbs',
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
};
